'use strict';

import * as Onyx from '../../lib/onyx.min.js';

export default class SceneGameover extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/gameover/index.html'
        });
    }

    onload(params){
        super.onload(params);

        // Add camera
		this.camera = new Onyx.Camera();
		this.add(this.camera);
		this.camera.transform.translate(0, 0, 0);
		// this.camera.lockY();
		this.viewports[0].bindToCamera(this.camera);

		//TODO: Make this DRY
		document.getElementById("score").innerHTML = document.getElementById("score").innerHTML.replace("${score}", params.score);

        game.sfx['timesUp'].play();
        game.sfx['timesUp'].volume(.5);
        // this.addSquishy();

        game.hideLoadingMask();
    }

    @Onyx.handles('click') //, {elementId: 'tryagain'}
    tryagain(){
        router.navigate("game");
    }

    update(...args){
        super.update(...args);
    }

    onunload(){
        super.onunload();

        game.music['game'].stop();
    }
}
